// Environment-specific configuration
const environments = {
  development: {
    api: {
      baseURL: "http://localhost:3001/api",
      timeout: 10000,
    },
    socialMedia: {
      // facebook: {
      //   url: "https://facebook.com/alhrmstore",
      //   enabled: true,
      // },
      twitter: {
        url: "https://x.com/alhrmstore?s=11&t=rhVukpy8RG8jtXYpkZLOtg",
        enabled: true,
      },
      instagram: {
        url: "https://www.instagram.com/alhrmstore?igsh=dHZ2cmcwMmo1OTl0",
        enabled: true,
      },
    },
    contact: {
      email: "dev@alhrmstore.com",
      phone: "+966 59 240 6070",
      whatsapp: "+966 59 240 6070",
    },
  },

  staging: {
    api: {
      baseURL: "https://staging-api.alhrmstore.com/api",
      timeout: 15000,
    },
    socialMedia: {
      facebook: {
        url: "https://facebook.com/alhrmstore",
        enabled: true,
      },
      twitter: {
        url: "https://x.com/alhrmstore?s=11&t=rhVukpy8RG8jtXYpkZLOtg",
        enabled: true,
      },
      instagram: {
        url: "https://www.instagram.com/alhrmstore?igsh=dHZ2cmcwMmo1OTl0",
        enabled: true,
      },
    },
    contact: {
      email: "staging@alhrmstore.com",
      phone: "+966 59 240 6070",
      whatsapp: "+966 59 240 6070",
    },
  },

  production: {
    socialMedia: {
      // facebook: {
      //   url: "https://facebook.com/alhrmstore",
      //   enabled: true,
      // },
      twitter: {
        url: "https://x.com/alhrmstore?s=11&t=rhVukpy8RG8jtXYpkZLOtg",
        enabled: true,
      },
      instagram: {
        url: "https://www.instagram.com/alhrmstore?igsh=dHZ2cmcwMmo1OTl0",
        enabled: true,
      },
    },
    contact: {
      email: "info@alhrmstore.com",
      phone: "+966 59 240 6070",
      whatsapp: "+966 59 240 6070",
    },
  },
};

// Get current environment
const getCurrentEnvironment = () => {
  return process.env.NODE_ENV || "development";
};

// Get environment-specific config
export const getEnvironmentConfig = () => {
  const env = getCurrentEnvironment();
  return environments[env] || environments.development;
};

export default getEnvironmentConfig;
